import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../../../actions/actionCreators';
import AdminNav from '../AdminNav/AdminNav';

class AdminApp extends React.Component {
    render() {
        return (
            <div className="AdminApp">
                <AdminNav />
                {/*{this.props.children}*/}
                {React.cloneElement(this.props.children, this.props)}
            </div>
        );
    }
}

function getPermissionLevel(permissions, userId) {
    const isAdvocate = permissions.associateAdvocates.find((advocate) => {
        return advocate === userId;
    });
    const isResource = permissions.resource.find((manager) => {
        return manager === userId;
    });

    if (isAdvocate) {
        return 'associateAdvocates';
    } else if(isResource) {
        return 'resource';
    }
}

// state.requests.filter((request) => {
//     const permissionLevel = getPermissionLevel(state.permissions, state.currentUser.userId);
//     console.log(permissionLevel);
//
//     if (permissionLevel === 'associateAdvocates') {
//         console.log(request.requestInfo.advocateId, state.currentUser.userId);
//         return request.requestInfo.advocateId === state.currentUser.userId;
//     } else if (permissionLevel === 'resource') {
//         return request;
//     }
// }),

function mapStateToProps(state) {
    return {
        users: state.users,
        currentUser: {
            ...state.currentUser,
            permission: getPermissionLevel(state.permissions, state.currentUser.userId)
        },
        requests: state.requests,
        permissions: state.permissions
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminApp);



/** WEBPACK FOOTER **
 ** ./src/components/Admin/AdminApp/AdminApp.js
 **/